export default {
  reports: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  exportReport: {
    isLoading: false,
    data: '',
    status: null,
    error: false,
    errorMessage: null
  },
};
